"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

type DesktopNavigateEvent = Event & {
  detail?: {
    href?: string;
  };
};

export function DesktopNavigationBridge() {
  const router = useRouter();

  useEffect(() => {
    const handleNavigate = (event: DesktopNavigateEvent) => {
      const href = event.detail?.href;
      if (!href) {
        return;
      }

      const url = new URL(href, window.location.href);
      if (url.origin !== window.location.origin) {
        return;
      }

      event.preventDefault();
      router.push(`${url.pathname}${url.search}${url.hash}`);
    };

    window.addEventListener("findin-desktop:navigate", handleNavigate);
    return () => {
      window.removeEventListener("findin-desktop:navigate", handleNavigate);
    };
  }, [router]);

  return null;
}
